import { ProjectName } from "../../constants/ProjectName";
import { PublicSiteUrl } from "../../constants/PublicSiteUrl";
const logo = "/logo192.png";


export default function PublicFooter() {
  return (
    <footer className="public-footer">
      <div className="public-container public-footer-inner">
        <div className="public-footer-brand">
          <span className="public-footer-logo">
            <img src={logo} alt="" />
          </span>

          <div>
            <strong>{ProjectName}</strong>
            <small>© {new Date().getFullYear()} {ProjectName}</small>
          </div>
        </div>

        <span className="public-footer-message">
          Made with care for therapists
        </span>

        <nav aria-label="Footer navigation">
          <a href={`${PublicSiteUrl}/privacy.html`}>Privacy</a>
          <a href={`${PublicSiteUrl}/terms.html`}>Terms</a>
          <a href={PublicSiteUrl}>Website</a>
        </nav>
      </div>
    </footer>
  );
}